import React, { Fragment } from 'react';
import { FlipCard, Intro, Voiceover } from 'dea-core';
import img1 from '../../assets/images/U1-T1-05A.jpg';
import img2 from '../../assets/images/U1-T1-05B.jpg';
import img3 from '../../assets/images/U1-T1-05C.jpg';
import voAudio from '../../assets/vo/Opioid-M-One-06-NEW.mp3';

const vo = {
  sources: [
    {
      src: voAudio
    }
  ],
  transcript:
    'What are prescription opioids for? When are we supposed to have a prescription opioid? What does it mean to misuse it? Click on each of the cards below to find out.'
};

const data = {
  cards: [
    {
      title: 'What are prescription opioids for?',
      frontOfCard: {
        header: 'What are prescription opioids for?',
        image: img1,
        imageAltText: 'Pill Bottles'
      },
      backOfCard: {
        text: (
          <Fragment>
            <p>
              Providing temporary relief from severe pain. <br />{' '}
            </p>
            <p>&nbsp;</p>
          </Fragment>
        ),
        image: img1,
        imageAltText: 'Pill bottles'
      }
    },
    {
      title: 'What kind of severe pain?',
      frontOfCard: {
        header: 'What kind of severe pain?',
        image: img2,
        imageAltText: 'Workplace injuries'
      },
      backOfCard: {
        text:
          'Cancer, kidney stones, and temporary relief for patients immediately after surgery or when experiencing extreme pain from physical trauma.',
        image: img2,
        imageAltText: 'Workplace injuries'
      }
    },
    {
      title: 'What does opioid prescription misuse entail?',
      frontOfCard: {
        header: 'What does opioid prescription misuse entail?',
        image: img3,
        imageAltText: 'Brain Cells'
      },
      backOfCard: {
        text: (
          <ul>
            <li>
              Not taking a prescription as directed, in dosage amount or
              frequency
            </li>
            <li>Taking it to get high</li>
            <li>Mixing it with other drug use</li>
            <li>Taking a prescription that was not prescribed to you</li>
          </ul>
        ),
        image: img3,
        imageAltText: 'Brain Cells'
      }
    }
  ]
};

export default {
  title: 'What are Prescription Opioids for? ',
  path: '/explain/prescription-opioids',
  content: (
    <Fragment>
      <Voiceover {...vo} />
      <Intro
        title="Prescription Opioids"
        direction="Flip each card to learn more."
      />
      <FlipCard data={data} />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/explain/PrescriptionOpioids.js